module.exports = __webpack_public_path__ + "img/Acc-4.da7d0179.png";